export const createSignInFormStore = async () => {
    const m = await import(
        /* webpackChunkName: 'SignInFormStore.js' */
        './SignInFormStore'
    );

    return new m.SignInFormStore();
};
